import React, { useEffect, useState } from 'react'
import { formatDistanceToNow } from 'date-fns'

export function TimeAgo({ date }: { date: string }) {
  const [timeAgo, setTimeAgo] = useState(
    formatDistanceToNow(new Date(date), { addSuffix: true }),
  )

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeAgo(formatDistanceToNow(new Date(date), { addSuffix: true }))
    }, 20000) // update every 20 seconds

    return () => clearInterval(interval) // cleanup on unmount
  }, [date])

  return <span>{timeAgo}</span>
}
